import { CoreMenu } from "@core/types";

export const menu: CoreMenu[] = [
  {
    id: "home",
    title: "Accueil",
    type: "section",
    icon: "home",
    role: [1], // Rétrocompatibilité
    permission: "dashboard.read", // Nouveau système
    children: [
      {
        id: "statistics",
        title: "Statistiques",
        type: "item",
        icon: "bar-chart-2",
        url: "utrav/home/statistics",
        role: [1],
        permission: "dashboard.read",
      },
    ],
  },

  {
    id: "pushNotifications",
    title: "Notifications",
    translate: "MENU.PUSH_NOTIFICATIONS",
    type: "section",
    role: [1, 2],
    permission: "notifications.read",
    children: [
      {
        id: "sendPush",
        title: "Envoyer notification",
        translate: "MENU.SEND_PUSH",
        type: "item",
        icon: "send",
        url: "utrav/push/send",
        role: [1, 2],
        permission: "notifications.create",
      },
      {
        id: "pushUsers",
        title: "Utilisateurs",
        translate: "MENU.PUSH_USERS",
        type: "item",
        icon: "users",
        url: "utrav/push/users",
        role: [1],
        permission: "users.read",
      },
      {
        id: "pushLogs",
        title: "Historique",
        translate: "MENU.PUSH_LOGS",
        type: "item",
        icon: "list",
        url: "utrav/push/logs",
        role: [1, 2],
        permission: "notifications.read",
      },
    ],
  },

  {
    id: "reviews",
    title: "Avis clients",
    translate: "MENU.REVIEWS",
    type: "section",
    role: [1, 2],
    permission: "reviews.read",
    children: [
      {
        id: "review",
        title: "Gestion des avis",
        type: "item",
        icon: "star",
        role: [1, 2],
        permission: "reviews.read",
        url: "utrav/review",
      },
    ],
  },
  {
    id: "trip-management",
    type: "section",
    title: "Gestion des voyages",
    icon: "package",
    role: [1, 2, 3],
    permission: "trips.read",
    children: [
      {
        id: "appointment",
        title: "Rendez-vous",
        role: [1, 2, 3],
        permission: "appointments.read",
        type: "item",
        url: "utrav/appointment/list",
        icon: "clock",
        children: [
          {
            id: "appointment-calendar",
            title: "Calendrier",
            type: "item",
            icon: "calendar",
            url: "utrav/appointment/calendar",
            role: [1, 2, 3],
            permission: "appointments.read",
          },
          {
            id: "appointment-list",
            title: "Liste des rendez-vous",
            type: "item",
            icon: "list",
            url: "utrav/appointment/list",
            role: [1, 2, 3],
            permission: "appointments.read",
          },
          {
            id: "appointment-availability",
            title: "Disponibilité",
            type: "item",
            icon: "user-check",
            url: "utrav/appointment/availability",
            role: [1, 2],
            permission: "appointments.update",
          },
        ],
      },
      {
        id: "booking",
        title: "Réservations",
        icon: "bookmark",
        type: "item",
        url: "utrav/booking",
        role: [1, 2, 3],
        permission: "bookings.read",
      },
      {
        id: "trips",
        title: "Voyages",
        type: "item",
        icon: "map",
        url: "utrav/trips",
        role: [1, 2, 3],
        permission: "trips.read",
      },
    ],
  },

  {
    id: "loyalty-management",
    title: "Gestion de la fidélité",
    type: "section",
    icon: "gift",
    role: [1, 2],
    permission: "loyalty.read",
    children: [
      {
        id: "loyalty",
        title: "Fidélité",
        type: "item",
        icon: "gift",
        url: "utrav/loyalty",
        role: [1, 2],
        permission: "loyalty.read",
      },
      {
        id: "users",
        title: "Utilisateurs",
        type: "item",
        icon: "users",
        url: "utrav/loyalty/users",
        role: [1, 2],
        permission: "loyalty.read",
      },

      {
        id: "loyalty-programs",
        title: "Programme",
        type: "item",
        icon: "award",
        url: "utrav/loyalty/programs",
        role: [1],
        permission: "loyalty.update",
      },
    ],
  },
  {
    id: "administration",
    title: "Administration",
    type: "section",
    icon: "settings",
    // Section visible si l'utilisateur a au moins une permission admin
    role: [1], // Rétrocompatibilité avec l'ancien système
    children: [
      {
        id: "roles",
        title: "Rôles & Permissions",
        type: "item",
        icon: "shield",
        url: "utrav/roles",
        role: [1], // Rétrocompatibilité
        permission: "roles.read", // Nouveau système de permissions
      },
      {
        id: "payments",
        title: "Paiements",
        type: "item",
        icon: "credit-card",
        url: "utrav/payments",
        role: [1],
        permission: "payments.read",
      },
      {
        id: "salary-conversions",
        title: "Salaires",
        type: "item",
        icon: "dollar-sign",
        url: "utrav/salary-conversions",
        role: [1],
        permission: "payments.update",
      },
      {
        id: "settings",
        title: "Marchands",
        type: "item",
        icon: "map-pin",
        url: "utrav/tenants",
        role: [1],
        permission: "tenants.read",
      },
    ],
  },
  {
    id: "global-admin",
    title: "Super Admin",
    type: "section",
    icon: "shield",
    globalAdminOnly: true,
    children: [
      {
        id: "data-import",
        title: "Import de données",
        type: "item",
        icon: "download-cloud",
        url: "utrav/administration",
        globalAdminOnly: true,
      },
      {
        id: "cgu",
        title: "CGU",
        type: "item",
        icon: "file-text",
        url: "utrav/cgu",
        role: [1],
        permission: "settings.read",
      },
      {
        id: "privacy-policy",
        title: "Politique de confidentialité",
        type: "item",
        icon: "file-text",
        url: "utrav/privacy-policy",
        role: [1],
        permission: "settings.read",
      },
    ],
  },
];
